module.exports = __webpack_public_path__ + "img/base.33a3e147.svg";